import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faYenSign as fortawesomefreesolidsvgicons_faYenSign,
  faMapMarkerAlt as fortawesomefreesolidsvgicons_faMapMarkerAlt,
  faGlasses as fortawesomefreesolidsvgicons_faGlasses,
  faUserCircle as fortawesomefreesolidsvgicons_faUserCircle,
  faTimesCircle as fortawesomefreesolidsvgicons_faTimesCircle,
  faBuilding as fortawesomefreesolidsvgicons_faBuilding,
  faComments as fortawesomefreesolidsvgicons_faComments,
  faTimes as fortawesomefreesolidsvgicons_faTimes,
  faEdit as fortawesomefreesolidsvgicons_faEdit,
  faExclamationCircle as fortawesomefreesolidsvgicons_faExclamationCircle,
  faArrowLeft as fortawesomefreesolidsvgicons_faArrowLeft,
  faArrowRight as fortawesomefreesolidsvgicons_faArrowRight,
  faChevronRight as fortawesomefreesolidsvgicons_faChevronRight,
  faChevronLeft as fortawesomefreesolidsvgicons_faChevronLeft,
  faChevronDown as fortawesomefreesolidsvgicons_faChevronDown,
  faCalendarAlt as fortawesomefreesolidsvgicons_faCalendarAlt,
  faLock as fortawesomefreesolidsvgicons_faLock,
  faUnlockAlt as fortawesomefreesolidsvgicons_faUnlockAlt,
  faPlus as fortawesomefreesolidsvgicons_faPlus,
  faTrashAlt as fortawesomefreesolidsvgicons_faTrashAlt,
  faSeedling as fortawesomefreesolidsvgicons_faSeedling,
  faFileContract as fortawesomefreesolidsvgicons_faFileContract,
  faCheckCircle as fortawesomefreesolidsvgicons_faCheckCircle,
  faStar as fortawesomefreesolidsvgicons_faStar,
  faSearch as fortawesomefreesolidsvgicons_faSearch,
  faEye as fortawesomefreesolidsvgicons_faEye,
  faExternalLinkAlt as fortawesomefreesolidsvgicons_faExternalLinkAlt,
  faSortDown as fortawesomefreesolidsvgicons_faSortDown,
  faPaperclip as fortawesomefreesolidsvgicons_faPaperclip,
  faPaperPlane as fortawesomefreesolidsvgicons_faPaperPlane,
  faEnvelope as fortawesomefreesolidsvgicons_faEnvelope,
  faFileAlt as fortawesomefreesolidsvgicons_faFileAlt,
  faQuestionCircle as fortawesomefreesolidsvgicons_faQuestionCircle,
  faUser as fortawesomefreesolidsvgicons_faUser,
  faUsers as fortawesomefreesolidsvgicons_faUsers,
  faCheck as fortawesomefreesolidsvgicons_faCheck
} from '@fortawesome/free-solid-svg-icons'

library.add(
  fortawesomefreesolidsvgicons_faYenSign,
  fortawesomefreesolidsvgicons_faMapMarkerAlt,
  fortawesomefreesolidsvgicons_faGlasses,
  fortawesomefreesolidsvgicons_faUserCircle,
  fortawesomefreesolidsvgicons_faTimesCircle,
  fortawesomefreesolidsvgicons_faBuilding,
  fortawesomefreesolidsvgicons_faComments,
  fortawesomefreesolidsvgicons_faTimes,
  fortawesomefreesolidsvgicons_faEdit,
  fortawesomefreesolidsvgicons_faExclamationCircle,
  fortawesomefreesolidsvgicons_faArrowLeft,
  fortawesomefreesolidsvgicons_faArrowRight,
  fortawesomefreesolidsvgicons_faChevronRight,
  fortawesomefreesolidsvgicons_faChevronLeft,
  fortawesomefreesolidsvgicons_faChevronDown,
  fortawesomefreesolidsvgicons_faCalendarAlt,
  fortawesomefreesolidsvgicons_faLock,
  fortawesomefreesolidsvgicons_faUnlockAlt,
  fortawesomefreesolidsvgicons_faPlus,
  fortawesomefreesolidsvgicons_faTrashAlt,
  fortawesomefreesolidsvgicons_faSeedling,
  fortawesomefreesolidsvgicons_faFileContract,
  fortawesomefreesolidsvgicons_faCheckCircle,
  fortawesomefreesolidsvgicons_faStar,
  fortawesomefreesolidsvgicons_faSearch,
  fortawesomefreesolidsvgicons_faEye,
  fortawesomefreesolidsvgicons_faExternalLinkAlt,
  fortawesomefreesolidsvgicons_faSortDown,
  fortawesomefreesolidsvgicons_faPaperclip,
  fortawesomefreesolidsvgicons_faPaperPlane,
  fortawesomefreesolidsvgicons_faEnvelope,
  fortawesomefreesolidsvgicons_faFileAlt,
  fortawesomefreesolidsvgicons_faQuestionCircle,
  fortawesomefreesolidsvgicons_faUser,
  fortawesomefreesolidsvgicons_faUsers,
  fortawesomefreesolidsvgicons_faCheck
)

config.autoAddCss = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
Vue.component('FontAwesomeLayersText', FontAwesomeLayersText)
